import { render } from "./ViewAllGiftCardsPage.vue?vue&type=template&id=d99787d0&scoped=true"
import script from "./ViewAllGiftCardsPage.vue?vue&type=script&lang=js"
export * from "./ViewAllGiftCardsPage.vue?vue&type=script&lang=js"

import "./ViewAllGiftCardsPage.vue?vue&type=style&index=0&id=d99787d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99787d0"]])

export default __exports__